import React from 'react';
import { Card } from 'primereact/card';
const ComingSoon = (props) => {
    return (React.createElement("div", { className: 'h-full w-full relative' },
        React.createElement("div", { className: "absolute top-50 left-50 relative text-center", style: { transform: 'translate(-50%,-50%)' } },
            React.createElement(Card, { className: 'center-content', title: "UNDER CONSTRUCTION", style: { width: '35rem', marginBottom: '2em' } },
                React.createElement("img", { src: "./assets/img/under-construction.png", alt: "", className: "comming-soon-image" })))));
};
export default ComingSoon;
